const getLocale = (state) => {
  return state.locale;
}

const trans = (state) => {
  const locale = state.locale;
  return (textConst) => locale[textConst] ?? textConst;
}

const getLanguages = (state) => {
  return state.languages;
}

export default {
  getLocale,
  trans,
  getLanguages,
}